"use client";
import { Button } from "@akashnetwork/ui/components";
import { cn } from "@akashnetwork/ui/utils";
import type { ClassValue } from "clsx";
import { Menu, Xmark } from "iconoir-react";
import Link from "next/link";

import { ACCOUNT_BAR_HEIGHT } from "@src/config/ui.config";
import useCookieTheme from "@src/hooks/useTheme";
import { AkashLogo } from "./AkashLogo";
import { WalletStatus } from "./WalletStatus";

export const Nav = ({
  isMobileOpen,
  handleDrawerToggle,
  className
}: React.PropsWithChildren<{
  isMobileOpen: boolean;
  handleDrawerToggle: () => void;
  className?: ClassValue;
}>) => {
  const theme = useCookieTheme();

  return (
    <header className={cn("fixed top-0 z-50 w-full border-b border-border/80 bg-header/85 shadow-[0_12px_40px_hsl(220_60%_2%/0.25)] backdrop-blur-xl", className)}>
      <div className="flex h-14 items-center justify-between px-4 md:px-6">
        {!!theme && (
          <Link className="flex items-center" href="/">
            <AkashLogo />
          </Link>
        )}

        <div>
          <Button size="icon" className="rounded-full border border-border/70 bg-card/70 text-foreground md:hidden" variant="ghost" onClick={handleDrawerToggle}>
            {isMobileOpen ? <Xmark /> : <Menu />}
          </Button>
        </div>

        <div style={{ height: `${ACCOUNT_BAR_HEIGHT}px` }} className={`hidden items-center md:flex`}>
          <div className="ml-4 flex items-center gap-2">
            <WalletStatus />
          </div>
        </div>
      </div>
    </header>
  );
};
